import * as Tooltip from "@radix-ui/react-tooltip";
import styled from "styled-components";
import { CaseInfoCard } from "./CaseInfoCard";
import { EvidenceInfoCard } from "./EvidenceInfoCard";

export type EntityInfoTooltipType = "case" | "evidence";

interface EntityInfoTooltipProps {
  type?: EntityInfoTooltipType;
  id?: string | null;
  children: React.ReactElement;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  delayDuration?: number;
}

const StyledContent = styled(Tooltip.Content)`
  background-color: ${({ theme }) => theme.palette.background.secondary};
  border: 1px solid ${({ theme }) => theme.palette.input.border};
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  min-width: 240px;
  max-width: 360px;
`;

export const EntityInfoTooltip = ({
  type,
  id,
  children,
  side = "right",
  align = "start",
  delayDuration = 400,
}: EntityInfoTooltipProps) => {
  if (!id || (type !== "case" && type !== "evidence")) {
    return <>{children}</>;
  }

  return (
    <Tooltip.Provider delayDuration={delayDuration}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <StyledContent
            side={side}
            sideOffset={8}
            align={align}
            onClick={(e) => e.stopPropagation()}
          >
            {type === "case" && <CaseInfoCard caseInfo={{ uuid: id }} />}
            {type === "evidence" && (
              <EvidenceInfoCard evidenceInfo={{ uuid: id }} />
            )}
          </StyledContent>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default EntityInfoTooltip;
